import { render, staticRenderFns } from "./activity-poster-submit.vue?vue&type=template&id=6a91b4e2&scoped=true&"
import script from "./activity-poster-submit.vue?vue&type=script&lang=js&"
export * from "./activity-poster-submit.vue?vue&type=script&lang=js&"
import style0 from "./activity-poster-submit.vue?vue&type=style&index=0&id=6a91b4e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a91b4e2",
  null
  
)

export default component.exports